import {
  InspectionConclusionEnum,
  InspectionOtherStandard,
  PrintColorInspect,
  StorageTemperature,
} from "commons/enum/inspection";
import { convertObjectToMobXModel } from "commons/ultilities";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { OptionItem } from "commons/ultilities/dynamic-form/models/control";
import { IAddUpdateDualLangInspectionNote } from "mobx-stores/_models/inspection-note/dual-lang-inspection-note/dual-lang-inspection-note";
import { IAddEditDualLangInspectionNoteItem } from "mobx-stores/_models/inspection-note/dual-lang-inspection-note/dual-lang-inspection-note-item";
import {
  DimensionAndWeight,
  IDimensionAndWeight,
  IDimensionAndWeightProperties,
} from "mobx-stores/_models/products/dimensionandweight";
import { IMaterial, Material } from "mobx-stores/_models/products/material";
import {
  IProduct,
  IProductProperties,
} from "mobx-stores/_models/products/product";
import { getLabelOfOthersStandard } from "pages/product";

export const getInspectionConclusionStatus = (): OptionItem[] => {
  return [
    {
      value: InspectionConclusionEnum.None,
      label: "-",
    },
    {
      value: InspectionConclusionEnum.Passed,
      label: "Đạt (Passed)",
    },
    {
      value: InspectionConclusionEnum.Failed,
      label: "Không đạt (Failed)",
    },
  ];
};

export const getStorageTemperatureOptions = (): OptionItem[] => {
  return [
    {
      value: StorageTemperature.ventilated,
      label: "Thông thoáng",
    },
    {
      value: StorageTemperature.StandardTemperature,
      label: "23°C - 32°C",
    },
  ];
};

export const getLabelOfStorageTemperature = (
  storageTemperature: string
): string => {
  if (storageTemperature === StorageTemperature.ventilated) {
    return "Thông thoáng";
  }
  if (storageTemperature === StorageTemperature.StandardTemperature) {
    return "23°C - 32°C";
  }
  return "";
};

export const getLabelOfConclusionStatus = (
  conclusionStatus: InspectionConclusionEnum
) => {
  if (conclusionStatus === InspectionConclusionEnum.None) {
    return "";
  }

  if (conclusionStatus === InspectionConclusionEnum.Passed) {
    return "Đạt (Passed)";
  }

  if (conclusionStatus === InspectionConclusionEnum.Failed) {
    return "K. đạt (Failed)";
  }
  return "";
};

export const getPrintColorInspectionOptions = (): OptionItem[] => {
  return [
    {
      value: PrintColorInspect.Standard,
      label: "Chuẩn (Standard)",
    },
    {
      value: PrintColorInspect.TooDark,
      label: "Hơi Đậm (Too Dark)",
    },
    {
      value: PrintColorInspect.TooLight,
      label: "Hơi Lợt (Too Light)",
    },
  ];
};

export const getLabelOfPrintColorInspection = (
  printColorInspect: PrintColorInspect
) => {
  if (printColorInspect === PrintColorInspect.Standard) {
    return "Chuẩn (Standard)";
  }

  if (printColorInspect === PrintColorInspect.TooDark) {
    return "Hơi Đậm (Too Dark)";
  }

  if (printColorInspect === PrintColorInspect.TooLight) {
    return "Hơi Lợt (Too Light)";
  }
  return "";
};

export const conclusionDefautText =
  "Lô hàng trên đã đạt tiêu chuẩn và đủ điều kiện để xuất giao hàng (The above-mentioned lot has met all required standards and is qualified for delivery)";

export const createPaperTypeStandard = (
  product: IProduct | IProductProperties
) => {
  let material = product.material as IMaterial;
  let upperAndLowerDisplay = ``;
  if (!material) return "";
  material = convertObjectToMobXModel(material, Material);
  if (
    material.gsmUpperWithFactorPercentDisplay ||
    material.gsmLowerWithFactorPercentDisplay
  ) {
    upperAndLowerDisplay = ` (${material.gsmUpperWithFactorPercentDisplay}${
      material.gsmLowerWithFactorPercentDisplay
        ? ", " + material.gsmLowerWithFactorPercentDisplay
        : 0
    })`;
  }
  return `${material?.paperType || ""} ${
    material?.gsmStandardDisplay || ""
  }g/m2${
    material.standard ? `, ${material.standard}` : ""
  }${upperAndLowerDisplay}`;
};

export const getOthersStandard = (
  productDimensionWeight: IDimensionAndWeightProperties
): string => {
  if (
    productDimensionWeight.otherStandardSelect ||
    productDimensionWeight.otherStandardText
  ) {
    const selectionLabel = getLabelOfOthersStandard(
      productDimensionWeight.otherStandardSelect as InspectionOtherStandard
    );
    return `${selectionLabel === "-" ? "" : selectionLabel || ""} ${
      productDimensionWeight.otherStandardText || ""
    }`;
  }
  return "";
};

export const createPaperTypeInspectText = (
  product: IProductProperties,
  paperTypeInspect: string
) => {
  return `${product.material?.paperType || ""} ${paperTypeInspect || 0}g/m2`;
};

export const createThicknessStandard = (
  product: IProduct | IProductProperties
) => {
  let material = product.material as IMaterial;
  if (!material) return "";
  material = convertObjectToMobXModel(material, Material);
  if (!material?.thicknessStandardDisplay) return "";
  let upperAndLowerDisplay = ``;
  if (
    material?.thicknessUpperWithFactorPercentDisplay ||
    material.thicknessLowerWithFactorPercentDisplay
  ) {
    upperAndLowerDisplay = ` (${
      material.thicknessUpperWithFactorPercentDisplay || ""
    }${
      material.thicknessLowerWithFactorPercentDisplay
        ? ", " + material.thicknessLowerWithFactorPercentDisplay
        : ""
    })`;
  }

  return `${material?.thicknessStandardDisplay}mm${upperAndLowerDisplay}`;
};

export const createWeightStandard = (
  product: IProductProperties | IProduct
) => {
  let dimensionWeight = product.dimensionWeight as IDimensionAndWeight;
  if (!dimensionWeight) return "";
  dimensionWeight = convertObjectToMobXModel(
    dimensionWeight,
    DimensionAndWeight
  );
  if (!dimensionWeight?.weightStandardDisplay) return "";
  let upperAndLowerDisplay = ``;
  if (
    dimensionWeight?.weightUpperWithFactorPercentDisplay ||
    dimensionWeight?.weightLowerWithFactorPercentDisplay
  ) {
    upperAndLowerDisplay = ` (${
      dimensionWeight.weightUpperWithFactorPercentDisplay || ""
    }${
      dimensionWeight.weightLowerWithFactorPercentDisplay
        ? ", " + dimensionWeight.weightLowerWithFactorPercentDisplay
        : ""
    })`;
  }
  return `${dimensionWeight?.weightStandardDisplay}gram${upperAndLowerDisplay}`;
};

export const createLengthStandard = (
  product: IProductProperties | IProduct
) => {
  let dimensionWeight = product.dimensionWeight as IDimensionAndWeight;
  if (!dimensionWeight) return "";
  dimensionWeight = convertObjectToMobXModel(
    dimensionWeight,
    DimensionAndWeight
  );
  if (!dimensionWeight?.lengthStandardDisplay) return "";
  let upperAndLowerDisplay = ``;

  if (
    dimensionWeight?.lengthUpperWithFactorNumberDisplay ||
    dimensionWeight?.lengthLowerWithFactorNumberDisplay
  ) {
    upperAndLowerDisplay = ` (${
      dimensionWeight.lengthUpperWithFactorNumberDisplay || ""
    }${
      dimensionWeight.lengthLowerWithFactorNumberDisplay
        ? ", " + dimensionWeight.lengthLowerWithFactorNumberDisplay
        : ""
    })`;
  }

  return `${dimensionWeight?.lengthStandardDisplay}mm${upperAndLowerDisplay}`;
};

export const createWidthStandard = (product: IProductProperties | IProduct) => {
  let dimensionWeight = product.dimensionWeight as IDimensionAndWeight;
  if (!dimensionWeight) return "";
  dimensionWeight = convertObjectToMobXModel(
    dimensionWeight,
    DimensionAndWeight
  );
  if (!dimensionWeight?.widthStandardDisplay) return "";
  let upperAndLowerDisplay = ``;

  if (
    dimensionWeight?.widthUpperWithFactorNumberDisplay ||
    dimensionWeight?.widthLowerWithFactorNumberDisplay
  ) {
    upperAndLowerDisplay = ` (${
      dimensionWeight.widthUpperWithFactorNumberDisplay || ""
    }${
      dimensionWeight.widthLowerWithFactorNumberDisplay
        ? ", " + dimensionWeight.widthLowerWithFactorNumberDisplay
        : ""
    })`;
  }

  return `${dimensionWeight?.widthStandardDisplay}mm${upperAndLowerDisplay}`;
};

export const createHeightStandard = (
  product: IProductProperties | IProduct
) => {
  let dimensionWeight = product.dimensionWeight as IDimensionAndWeight;
  if (!dimensionWeight) return "";
  dimensionWeight = convertObjectToMobXModel(
    dimensionWeight,
    DimensionAndWeight
  );
  if (!dimensionWeight?.heightStandardDisplay) return "";
  let upperAndLowerDisplay = ``;

  if (
    dimensionWeight?.heightUpperWithFactorNumberDisplay ||
    dimensionWeight?.heightLowerWithFactorNumberDisplay
  ) {
    upperAndLowerDisplay = ` (${
      dimensionWeight.heightUpperWithFactorNumberDisplay || ""
    }${
      dimensionWeight.heightLowerWithFactorNumberDisplay
        ? ", " + dimensionWeight.heightLowerWithFactorNumberDisplay
        : ""
    })`;
  }

  return `${dimensionWeight?.heightStandardDisplay}mm${upperAndLowerDisplay}`;
};

export const createApprovalStandard = (product: IProductProperties) => {
  if (!product.approval?.businessDate) return "";
  return `Số: ${
    product.approval?.businessNumber || ""
  }, Ngày ký: ${dateTimeDisplay(product.approval?.businessDate || "")}`;
};

export const createPrintColorStandard = (product: IProductProperties) => {
  if (!product.approval?.printDate) return "";
  return `Số: ${
    product.approval?.printNumber || ""
  }, Ngày ký: ${dateTimeDisplay(product.approval?.printDate || "")}`;
};

export const expiryDateDefaultText = "3 năm sau ngày sản xuất";
export const storageTemperatureDefaultText = "18°C - 26°C";
export const appearanceDefaultText =
  "Độ bóng tốt, không trầy xước, dao bế chính xác, gấp dán đúng vị trí & hộp không biến dạng (Good coating, no scratches, accurate die-cut, proper folding and gluing & box is not deformed)";
export const approvalInspectDefaultText = "Đúng Mẫu (Matches)";
export const apperanceInspectDefaultText =
  "Đạt Tiêu Chuẩn (Meet The Standards)";
export const otherInspectDefaultText = "Đúng Mẫu (Matches)";
export const inspectionItemDefaultValues: IAddEditDualLangInspectionNoteItem = {
  appearanceResult: InspectionConclusionEnum.None,
  approval: "",
  approvalResult: InspectionConclusionEnum.None,
  approvalStandard: "",
  height: "",
  heightResult: InspectionConclusionEnum.None,
  heightStandard: "",
  length: "",
  lengthResult: InspectionConclusionEnum.None,
  lengthStandard: "",
  otherStandard: "",
  otherStandardResult: InspectionConclusionEnum.None,
  paperType: "",
  paperTypeInspecctionStandard: "",
  paperTypeInspect: null,
  paperTypeResult: InspectionConclusionEnum.None,
  printColor: "",
  printColorResult: InspectionConclusionEnum.None,
  printColorStandard: "",
  thickness: "",
  thicknessResult: InspectionConclusionEnum.None,
  thicknessStandard: "",
  weight: "",
  weightResult: InspectionConclusionEnum.None,
  weightStandard: "",
  width: "",
  widthResult: InspectionConclusionEnum.None,
  widthStandard: "",
  appearanceInspectionStandard: appearanceDefaultText,
  appearanceInspect: apperanceInspectDefaultText,
  approvalInspect: approvalInspectDefaultText,
  conclusion: conclusionDefautText,
  heightInspect: null,
  lengthInspect: null,
  otherStandardInspect: otherInspectDefaultText,
  thicknessInspect: null,
  printColorInspect: PrintColorInspect.Standard,
  weightInspect: null,
  widthInspect: null,
  productId: "",
  apperance: "",
  otherStandardInspectionStandard: "",
};

export const inspectionDefaultValues: IAddUpdateDualLangInspectionNote = {
  expireDateText: expiryDateDefaultText,
  inspectionDate: "",
  number: "",
  workOrderPOId: "",
  conclusion: conclusionDefautText,
  customerId: "",
  deliveredQuantity: null,
  inspectionSamples: null,
  inspector: "",
  note: "",
  packagesQuantity: null,
  purchaseOrderId: "",
  quantityPerPackage: null,
  storageTemperature: StorageTemperature.ventilated,
};
